// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PaymentProviderIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PaymentProvider/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.364,
  d: "M6.192 14.57c0 1.132.868 2.044 1.947 2.044h2.202c.938 0 1.701-.798 1.701-1.78 0-1.071-.464-1.448-1.158-1.694L7.35 11.912c-.693-.246-1.157-.623-1.157-1.693 0-.982.763-1.78 1.701-1.78h2.202c1.079 0 1.947.912 1.947 2.043M9.11 7.263V17.79M16.557 8.096l3.782-3.783v2.522M20.34 4.314h-2.522M20.709 10.572l-3.783 3.783v-2.522M16.926 14.355h2.522"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.364,
  d: "m15.665 2.625-2.631 1.25-3.685-1.25-3.465 1.25L1.981 2v20l3.903-1.875L9.35 22l3.685-1.875L16.718 22v-3.971"
}));
export default PaymentProviderIcon;
